<template>
    <div class="legal-person">
        <menuBox :step="4"></menuBox>
        <div class="banner">
            精英簡介
        </div>
        <div class="text-box">
            <div class="title">林毅</div>
            <div class="text">
                所在公司主要從事互聯網廣告，FB&Google 投放代理。服務了超過10家電商，遊戲和工具產品產品。 2020年被appsflyer 評選為東南亞優質合作夥伴。 2021年被評選Facebok top3金融合作夥伴。
                <br>
                華中科技大學 電子科學與技術 碩士 （2009年9月-2011年7月）
                <br> 華中科技大學 電子信息與工程 本科 （2005年9月-2009年7月）

               <br>工作經歷：組建百度印尼無線產品團隊（25人左右），承接無線產品本地運營和Marketing工作，構建本地原創內容及遊戲發行能力。
                <br> 組建本地遊戲發行團隊，和中國CP深度定制一款印尼特色RPG卡牌遊戲，本地負責人物設計，故事背景，核心戰鬥及養成規劃、運營、推廣及市場。
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.banner{
    width: 100%;
    height: 480px;
    background: url(../assets/banner-2.png);
    background-size: 100% 100%;
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}
.text-box{
    padding: 120px 360px;
    .title{
        font-size: 40px;
        font-weight: 500;
        color: #1C539D;
    }
    .text{
        font-size: 18px;
        font-weight: 500;
        color: #999999;
        margin-top: 32px;
    }
}
</style>